import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pvz-filters" }
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
      class: "mt-6 bg-white border px-6 py-4"
    }, [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: "Название",
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-3",
        value: _ctx.state.cityId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cityId) = $event)),
        placeholder: "Город",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
        onSearch: _ctx.searchCity,
        onOptionBySearch: _ctx.unshiftFindedCity
      }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_button, {
          class: "second text small mr-2",
          loading: _ctx.loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Сброс ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}